import React from 'react';
import viewReadyTracker from '../../services/ViewReadyTracker';
import styles from './RouteNotFound.scss';

class RouteNotFound extends React.PureComponent {
    componentDidMount() {
        viewReadyTracker.getReporter()(true);
    }

    render() {
        return (
            <div className={styles.notFound} role="main">
                <i className="fa fa-question fa-3x fa-fw margin-bottom" />
                <span className="sr-only">Route not found...</span>
            </div>
        );
    }
}

export default RouteNotFound;
